import useOrdersDashboard from 'features/orders/hooks/useOrdersDashboard';
import { useMemo } from 'react';
import { showOrderCount } from 'utils/dashboardUtils';

const LAST_DAYS = 30;

export interface OrderOverviewStats {
    ordersToFulfill: number;
    fulfilledLast30Days: number;
    totalFulfilled: number;
    isLoading: boolean;
}

/**
 * Shop-wide order counts for the dashboard's order overview. "Last 30 days" filters on the orders'
 * date (the orders list's own date range filter), counted from the start of the day 30 days ago.
 */
export const useOrderOverviewStats = (): OrderOverviewStats => {
    // Fixed for the component's lifetime: the dates are part of the SWR key, so a fresh `new Date()`
    // on every render would refetch on every render.
    const last30DaysRange = useMemo(() => {
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - LAST_DAYS);
        startDate.setHours(0, 0, 0, 0);
        return { startDate };
    }, []);

    const unfulfilled = useOrdersDashboard('unfulfilled');
    const fulfilledLast30Days = useOrdersDashboard('fulfilled', last30DaysRange);
    const fulfilled = useOrdersDashboard('fulfilled');

    return {
        ordersToFulfill: showOrderCount(unfulfilled.meta),
        fulfilledLast30Days: showOrderCount(fulfilledLast30Days.meta),
        totalFulfilled: showOrderCount(fulfilled.meta),
        isLoading: unfulfilled.loading || fulfilledLast30Days.loading || fulfilled.loading,
    };
};
